import React from "react";
import styles from "./Table.module.css";

interface TableProps {
  regionName: string;
  storageNames: string[];
}

export const Table: React.FC<TableProps> = ({ regionName, storageNames }) => {
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                Данные по области <span className={styles.headerStrong}>{regionName}</span>
            </div>
            <input
                type="text"
                placeholder="Поиск"
                className={styles.search}
            />
            <div className={styles.tableTitle}>
                Предприятия
            </div>
            {storageNames.length === 0 ? (
              <div className={styles.tableRow}>Нет данных</div>
            ) : (
              storageNames.map((name, idx) => (
                <div className={styles.tableRow} key={idx}>
                  {name}
                </div>
              ))
            )}
        </div>
    );
};